var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs hidden-print"},[_c('ul',_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:[
        'tab',
        { 'is-active': _vm.activeTab === tab.tab },
        { 'is-main': tab.tab === 'customer' } ]},[_c('a',{on:{"click":function($event){return _vm.selectTab(tab.tab)}}},[_vm._v(_vm._s(tab.tabLabel))]),(tab.hasData)?_c('span',{staticClass:"dot"}):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }